import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import Knots from "../../../../../../domain/units/Knots";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";
import { NauticalMiles } from "../../../../../../domain/units/NauticalMiles";
import { eqeqeq } from "../../../../../../shared/utils/equality";

const fieldName = "Current Speed";

const CurrentSpeedFormItemProvider: FormItemProvider<Knots> = (props: FormItemProviderProps<NauticalMiles>) => (
  <GenericNumberFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="CurrentSpeed"
    addonAfter="kt"
    allowNegative={false}
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new Knots(input)))}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(CurrentSpeedFormItemProvider);